import { EVENTQ_TOAST_DEFAULT_ICONS } from './toast-default-icons';

export type EventqToastVariantId =
  | 'snapshot-captured'
  | 'snapshot-failed'
  | 'raised-to-resolve'
  | 'ai-feedback-received'
  | 'ai-feedback-failed'
  | 'event-closed'
  | 'event-parked'
  | 'camera-issue-reported'
  | 'auto-process-on'
  | 'auto-process-off'
  | 'site-armed'
  | 'site-disarmed'
  | 'alarm-clip-attached'
  | 'alarm-clip-attach-failed'
  | 'download-failed'
  | 'download-resolved'
  | 'incident-report-created'
  | 'evidence-delete-failed'
  | 'notice';

/** Color treatment. When omitted, the variant's built-in color is used. */
export type EventqToastTone = 'error' | 'success';

export type EventqToastPosition = 'top-right' | 'bottom-right';

export interface EventqToastMessage {
  readonly id: string;
  readonly variantId: EventqToastVariantId;
  readonly title: string;
  readonly subtitle: string;
  readonly iconSrc: string;
  readonly durationMs: number;
  readonly tone?: EventqToastTone;
  readonly exiting?: boolean;
}

export interface EventqToastShowOptions {
  readonly title?: string;
  readonly subtitle?: string;
  readonly durationMs?: number;
  /** Optional override; when omitted, the variant’s built-in default icon is used. */
  readonly iconSrc?: string;
  /** Use another variant's icon without taking that variant's title or color. */
  readonly icon?: EventqToastVariantId;
  /** Replaces the variant color. `error` is the red failure toast; `success` is green. */
  readonly tone?: EventqToastTone;
}

export const EVENTQ_TOAST_DEFAULT_DURATION_MS = 3000;
export const EVENTQ_TOAST_EXIT_ANIMATION_MS = 220;

export const EVENTQ_TOAST_PRESETS: Record<
  EventqToastVariantId,
  Pick<EventqToastMessage, 'title' | 'iconSrc'>
> = {
  'snapshot-captured': {
    title: 'Snapshot Captured',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.SNAPSHOT_CAPTURED,
  },
  'snapshot-failed': {
    title: 'Snapshot Failed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.SNAPSHOT_CAPTURED,
  },
  'raised-to-resolve': {
    title: 'Raised to Resolve',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.RAISED_TO_RESOLVE,
  },
  'ai-feedback-received': {
    title: 'AI Feedback Recieved',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.AI_FEEDBACK,
  },
  'ai-feedback-failed': {
    title: 'AI Feedback Failed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.AI_FEEDBACK,
  },
  'event-closed': {
    title: 'Event Closed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.EVENT_CLOSED,
  },
  'event-parked': {
    title: 'Event Parked',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.EVENT_PARKED,
  },
  'camera-issue-reported': {
    title: 'Camera Issue Reported',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.CAMERA_REPORTED,
  },
  'auto-process-on': {
    title: 'Auto-Process Turned On',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.AUTO_PROCESS,
  },
  'auto-process-off': {
    title: 'Auto-Process Turned Off',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.AUTO_PROCESS,
  },
  'site-armed': {
    title: 'Site Armed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.SITE_ARMED,
  },
  'site-disarmed': {
    title: 'Site Disarmed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.SITE_DISARMED,
  },
  'alarm-clip-attached': {
    title: 'Alarm Clip Added to Resolve',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.ADD_VIDEO_CLIP,
  },
  'alarm-clip-attach-failed': {
    title: 'Unable to add Alarm Clip',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.ADD_VIDEO_CLIP,
  },
  'download-failed': {
    title: 'Download Failed',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.DOWNLOAD_FAILED,
  },
  'download-resolved': {
    title: 'Download Successful',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.DOWNLOAD_RESOLVED,
  },
  'incident-report-created': {
    title: 'Incident Report Created',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.CAMERA_REPORTED,
  },
  'evidence-delete-failed': {
    title: 'Unable to delete evidence',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.DOWNLOAD_FAILED,
  },
  notice: {
    title: 'Notice',
    iconSrc: EVENTQ_TOAST_DEFAULT_ICONS.NOTICE,
  },
};
